import React, { useState } from 'react'
import { buyDonate, IDonate } from '../../api/donate'
import { Button, Card } from 'antd'
import { getState } from '../../redux/store'
import { useHistory } from 'react-router'
import { DonateCardModal } from './DonateCardModal'
import { routePathSignIn } from './SignIn'
import { signOut } from '../../api/signIn'

export const DonateCard = ({ donate } : { donate: IDonate }): React.ReactElement => {
	const [visible, setIsVisible] = useState(false)
	const [loading, setIsLoading] = useState(false)

	const user = getState(s => s.user)
	const history = useHistory()

	const handleBuy = async () => {
		const res = await buyDonate(donate.productCode)

		setIsLoading(false)

		if (res.success) {
			window.location.href = res.link
		} else {
			await signOut()
			history.push(routePathSignIn)
		}
	}

	return (
		<>
			<DonateCardModal
				donate={donate}
				visible={visible}
				onClose={() => setIsVisible(false)}
			/>

			<Card
				hoverable
				style={{ width: 280, height: 500, display: 'flex', flexDirection: 'column' }}
				cover={<img src={donate.image} alt="donate image"/>}
				bodyStyle={{
					display: 'flex',
					flexDirection: 'column',
					flex: 1
				}}
			>
				<Card.Meta
					title={donate.product}
					description={donate.smallDescription}
				/>

				<div style={{
					display: 'flex',
					marginTop: 'auto',
					flexDirection: 'row'
				}}>
					<Button
						loading={loading}
						key="buy"
						type="primary"
						onClick={() => {
							if (!user.nick) {
								history.push(routePathSignIn)
							} else {
								setIsLoading(true)
								void handleBuy()
							}
						}}
					>
						Купить
					</Button>

					{donate.isDescriptionEnabled ? (
						<Button
							disabled={loading}
							key="show-desc"
							style={{ marginLeft: '5%' }}
							onClick={() => setIsVisible(true)}
						>
							Подробнее
						</Button>
					) : <></>}
				</div>
			</Card>
		</>
	)
}
